module.exports = __webpack_public_path__ + "static/media/narfo_safety.2b66ed0c.jpg";